import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M1.997 19h13.436c.828 0 1.498-.685 1.498-1.53V6.53c0-.845-.67-1.53-1.498-1.53H1.997C1.17 5 .5 5.685.5 6.53v10.94c0 .845.67 1.53 1.497 1.53zm22.777-1.734l-5.163-2.683V9.417l5.163-2.683c.33-.172.722.076.722.455v9.622c0 .383-.39.628-.722.455z" }));
export default createSvgIcon(iconPath, "Video");
//# sourceMappingURL=VideoIcon.js.map